/* eslint-disable */
import React from 'react';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import AgeSelector from 'src/onboarding/components/ui/ageSelector/AgeSelector';
import Button from 'src/onboarding/components/ui/button/Button';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';

function Page() {
  const born = useStore((state) => state.born);
  const setBorn = useStore((state) => state.setBorn);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.born_new.title')}</Title>
        <Text size='m' medium className={'description'} style={{ padding: 0 }}>
          {t('onboarding.born_new.subTitle')}
        </Text>
      </div>

      <div className={'controls controls_new'}>
        <AgeSelector onChange={(newValue) => setBorn(newValue)} initialValue={Number(born)} />
      </div>
      {born <= 17 && (
        <Caption size='m' className={'error-message'}>
          {t('onboarding.born_new.errorMessage')}
        </Caption>
      )}
      <div className={'next-wrapper'}>
        <Button
          className={born <= 17 && 'disabled'}
          title={t('onboarding.born_new.continue')}
          onClick={() => {
            if (born <= 17) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'born',
              answer: born,
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
